
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_n1fwt_inzpg_13",
  "header-inner": "awsui_header-inner_n1fwt_inzpg_45",
  "header": "awsui_header_n1fwt_inzpg_45",
  "body": "awsui_body_n1fwt_inzpg_54",
  "footer": "awsui_footer_n1fwt_inzpg_62",
  "refresh": "awsui_refresh_n1fwt_inzpg_128",
  "highlighted": "awsui_highlighted_n1fwt_inzpg_131",
  "variant-embedded": "awsui_variant-embedded_n1fwt_inzpg_138",
  "inner-card": "awsui_inner-card_n1fwt_inzpg_138",
  "variant-default": "awsui_variant-default_n1fwt_inzpg_138",
  "no-padding": "awsui_no-padding_n1fwt_inzpg_144",
  "with-actions": "awsui_with-actions_n1fwt_inzpg_169",
  "full-height": "awsui_full-height_n1fwt_inzpg_215",
  "description": "awsui_description_n1fwt_inzpg_219"
};
  